/** Tier 1 ETF catalog labels (mirrors backend `etf-sleeve.catalog.ts`). */
export const TIER1_ETF_CATALOG: Array<{
  sleeveKey: string;
  primarySymbol: string;
  label: string;
}> = [
  { sleeveKey: 'treasuries_short', primarySymbol: 'SHY', label: 'Short Treasuries' },
  { sleeveKey: 'treasuries_long', primarySymbol: 'TLT', label: 'Long Treasuries' },
  { sleeveKey: 'corporate_credit', primarySymbol: 'LQD', label: 'Corporate credit' },
  { sleeveKey: 'gold', primarySymbol: 'GLD', label: 'Gold' },
  { sleeveKey: 'real_estate', primarySymbol: 'VNQ', label: 'Real estate' },
  { sleeveKey: 'usd', primarySymbol: 'UUP', label: 'US dollar' },
  { sleeveKey: 'cash', primarySymbol: 'BIL', label: 'Cash / T-bills' },
  { sleeveKey: 'technology', primarySymbol: 'XLK', label: 'Technology' },
  { sleeveKey: 'consumer_staples', primarySymbol: 'XLP', label: 'Consumer staples' },
  { sleeveKey: 'consumer_discretionary', primarySymbol: 'XLY', label: 'Consumer discretionary' },
  { sleeveKey: 'energy', primarySymbol: 'XLE', label: 'Energy' },
  { sleeveKey: 'healthcare', primarySymbol: 'XLV', label: 'Healthcare' },
  { sleeveKey: 'financials', primarySymbol: 'XLF', label: 'Financials' },
  { sleeveKey: 'industrials', primarySymbol: 'XLI', label: 'Industrials' },
  { sleeveKey: 'utilities', primarySymbol: 'XLU', label: 'Utilities' },
];

export function tier1EtfLabel(symbol: string, sleeveKey?: string): string | undefined {
  if (sleeveKey) {
    const bySleeve = TIER1_ETF_CATALOG.find((e) => e.sleeveKey === sleeveKey);
    if (bySleeve) return bySleeve.label;
  }
  const sym = symbol.trim().toUpperCase();
  return TIER1_ETF_CATALOG.find((e) => e.primarySymbol === sym)?.label;
}

export function yahooFinanceUrl(symbol: string): string {
  return `https://finance.yahoo.com/quote/${encodeURIComponent(symbol.trim().toUpperCase())}/`;
}
